import moment, { Moment } from 'moment';
import React, { useEffect, useState } from 'react';
import { SessionTimeoutProps } from './sessionTimeout.config';

const SessionTimeout: React.FC<SessionTimeoutProps> = (props) => {
  let timer: any = undefined;
  const events = ['click', 'scroll', 'load', 'keydown', 'mousemove'];
  const eventHandler = (eventType: any) => {
    localStorage.setItem('lastInteractionTime', moment().toString());
    if (timer) {
      props.onActive();
      startTimer();
    }
  };

  useEffect(() => {
    if (props.userState.sessionTime && props.userState.sessionTime > 0 && props.userState.authenticated) {
      addEvents();
    }

    return () => {
      removeEvents();
      clearTimeout(timer);
    };
  }, [props.userState.sessionTime]);

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      let lastInteractionTime = localStorage.getItem('lastInteractionTime');
      const diff = moment.duration(moment().diff(moment(lastInteractionTime)));
      let timeOutInterval = props.userState.sessionTime * 1000 * 60;
      if (!timeOutInterval) return;
      if (diff.asMilliseconds() < timeOutInterval) {
        startTimer();
        props.onActive();
      } else {
        props.onIdle();
        clearTimeout(timer);
      }
    }, props.userState.sessionTime * 1000 * 60);
  };
  const addEvents = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });

    startTimer();
  };

  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  return <></>;
};

export default SessionTimeout;
